
import React from "react";
import { ServiceHero, ServiceHeroProps } from "./ServiceHero";
import { ServiceFeatures, FeatureItem } from "./ServiceFeatures";
import { ServiceProcess, ProcessStep } from "./ServiceProcess";
import { ServiceBenefits, BenefitItem } from "./ServiceBenefits";
import { ServiceCTA } from "./ServiceCTA";
import { ServiceContactForm } from "./ServiceContactForm";
import { FloatingContactButton } from "../services/FloatingContactButton";

interface ServiceLandingPageProps {
  title: string;
  metaDescription: string;
  introText: string;
  features: FeatureItem[];
  processSteps: ProcessStep[];
  benefits: BenefitItem[];
  ctaText: string;
  ctaButtonText: string;
  contactText: string;
  heroImageUrl?: string;
  heroImageAlt?: string;
}

export const ServiceLandingPage = ({
  title,
  metaDescription,
  introText,
  features,
  processSteps,
  benefits,
  ctaText,
  ctaButtonText,
  contactText,
  heroImageUrl,
  heroImageAlt,
}: ServiceLandingPageProps) => {
  return (
    <div className="relative">
      <ServiceHero
        title={title}
        description={introText}
        imageUrl={heroImageUrl}
        imageAlt={heroImageAlt || title}
      />
      <ServiceFeatures features={features} />
      <ServiceProcess steps={processSteps} />
      <ServiceBenefits benefits={benefits} />
      <ServiceCTA text={ctaText} buttonText={ctaButtonText} />
      <ServiceContactForm title={title} description={contactText} />
      
      {/* Floating Contact Button */}
      <FloatingContactButton serviceName={title} />
    </div>
  );
};
